import { useCallback, useState } from 'react';
import { useParams } from '@direct-frontend/modules-router';
import { useFormInstance } from '@adv-frontend/form-kit';
import { getOrderPayboxPayURL } from '@/entities/order';
import { ORDER_FORM_ID, orderForm, type OrderPayboxSubmitParams } from '@/features/OrderForm';
import { modalsService } from '@/shared/lib/modalsService';
import { getRequestContext } from '@/shared/lib/requestContext';

interface UsePayboxSubmitParams {
    orderId: string;
    signature: string;
}

export const usePayboxSubmit = ({ orderId, signature }: UsePayboxSubmitParams) => {
    const formInstance = useFormInstance({ form: orderForm, id: ORDER_FORM_ID });
    const { storeSlug = '' } = useParams();
    const { company } = getRequestContext();

    const [payboxUrl, setPayboxUrl] = useState('');

    const handlePayboxSubmit = useCallback(
        async (params: OrderPayboxSubmitParams) => {
            try {
                const result = await formInstance.submit();

                if (!result?.isSuccess) {
                    return;
                }

                if (!company.companyShopUrl) {
                    throw new Error('companyShopUrl must be defined');
                }

                const data = await getOrderPayboxPayURL({
                    order_id: orderId,
                    signature,
                    store_slug: storeSlug,
                    initial_payment_options: JSON.stringify(params.initial_payment_options),
                    on_success_redirect: company.companyShopUrl,
                    on_error_redirect: company.companyShopUrl,
                    on_abort_redirect: company.companyShopUrl,
                });

                setPayboxUrl(data.url);
                modalsService.onPayBoxModal();
            } catch (error) {
                console.error(error);
            }
        },
        [formInstance, orderId, signature, storeSlug, company.companyShopUrl]
    );

    return { handlePayboxSubmit, payboxUrl };
};
